import React from 'react';
import { useTranslation } from 'react-i18next';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import { getRelatedContentBlock } from '../../../DeviationViews/_helpers';
var TOOLTIP_WIDTH_PX = 256;
/** The owner's SubscribersOnly tooltip contains info about how many tiers
 *  contain the deviation and those tier titles that isn't used in the other tooltips. */
var SubscribersOnlyOwnersTooltip = function (_a) {
    var _b, _c;
    var deviation = _a.deviation, linkClassName = _a.linkClassName, children = _a.children;
    var t = useTranslation().t;
    var _d = useSubscriptionTier(deviation), tier = _d.tier, isTier = _d.isTier, isOwner = _d.isOwner, subscriptionsTabUrl = _d.subscriptionsTabUrl;
    // no tooltip for tier deviation viewed by owner
    if (!tier || !isOwner || isTier) {
        return React.createElement(React.Fragment, null, children);
    }
    // when the owner is viewing an in-tier, we show a list of the tiers
    // containing this deviation in the description and a count in the heading
    var inTiers = (_c = (_b = getRelatedContentBlock(deviation, 'in_tiers')) === null || _b === void 0 ? void 0 : _b.deviations) !== null && _c !== void 0 ? _c : [];
    return (React.createElement(SophisticatedTooltip, { size: "large", placement: "top", width: TOOLTIP_WIDTH_PX, heading: t('deviation.tier.subscribersOnly.tooltip.owner.tierCount', {
            // note: the inTiers list includes the current tier
            count: inTiers.length,
        }), description: inTiers.map(function (otherTier) { return otherTier.title; }).join('\n'), postfix: React.createElement(SophisticatedTooltipLink, { href: subscriptionsTabUrl, className: linkClassName }, t('deviation.tier.subscribersOnly.tooltip.subscriptionsLinkOwner')) }, children));
};
SubscribersOnlyOwnersTooltip.displayName = 'SubscribersOnlyOwnersTooltip';
export default SubscribersOnlyOwnersTooltip;
//# sourceMappingURL=SubscribersOnlyOwnersTooltip.js.map